import React from 'react';

import Medicalinstrum from './Medicalinstrum';
import Medicalinst from './Medicalinst';
import Stainless from './Stainless';


const Petperforminje = () => {
    return (
        <div>
            <Medicalinstrum />
            <Medicalinst />
            <Stainless />
        </div>
    );
};

export default Petperforminje;
